import { produce } from 'immer';

import { OneTrustActionTypes, OneTrustStatus, OneTrustConsentModel } from './oneTrustTypes';
import { OneTrustActions } from './oneTrustActions';

export type OneTrustReducerState = {
    status: OneTrustStatus;
    consentModel: OneTrustConsentModel | null;
    showBanner: boolean;
};

const initialState: OneTrustReducerState = {
    status: OneTrustStatus.UNFETCHED,
    consentModel: null,
    showBanner: false,
};

export default (state: OneTrustReducerState = initialState, action: OneTrustActions): OneTrustReducerState => {
    switch (action.type) {
        case OneTrustActionTypes.ONE_TRUST_SET_STATUS:
            return produce(state, (draft) => {
                draft.status = action.status;
            });
        case OneTrustActionTypes.ONE_TRUST_SET_CONSENT_MODEL:
            return produce(state, (draft) => {
                draft.consentModel = action.consentModel;
            });
        case OneTrustActionTypes.ONE_TRUST_SHOW_BANNER:
            return produce(state, (draft) => {
                draft.showBanner = true;
            });
        case OneTrustActionTypes.ONE_TRUST_HIDE_BANNER:
            return produce(state, (draft) => {
                draft.showBanner = false;
            });
        default:
            return state;
    }
};
